import React from 'react';

function TokenAuthorizationTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>🔐 进行代币授权</h3>
      
      <div className="tutorial-steps">
        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 连接币安钱包</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            如果没经过初次授权，上面会有一个连接钱包按钮，点击选择binance wallet。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/connect-wallet.png"
              alt="连接币安钱包"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 连接币安钱包界面图片
            </div>
          </div>
        </div>

        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤2: 扫描二维码</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            弹出来二维码会比较慢, 要等一阵, 网不好可能甚至要等十分钟，但是总归会弹出来的。然后用币安app扫码。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/scan-qr-code.png"
              alt="扫描二维码"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 扫描二维码界面图片
            </div>
          </div>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            扫出来也可能比较卡, 总之点确定来连上。
          </p>
          <img 
              src="/images/scan-qr-code1.png"
              alt="扫描二维码"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
             <img 
              src="/images/scan-qr-code2.png"
              alt="扫描二维码"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
        </div>

        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤3: 授权代币</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            连上之后点击授权代币按钮，会显示一个授权，同意就行(刷分计划里选的是什么这里就会是什么)。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/authorize-token.png"
              alt="授权代币"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <img 
              src="/images/authorize-token1.png"
              alt="授权代币"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 授权代币界面图片
            </div>
          </div>
        </div>
        
        <div className="tutorial-note" style={{
          backgroundColor: '#e2f3ff',
          padding: '15px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4 style={{ color: '#0069d9', marginBottom: '10px' }}>注意事项:</h4>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            这一步币安弹出确认也可能会因为网络问题等好久，甚至会等五分钟。请耐心等待。
          </p>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            注意，前面那些授权一个钱包只用做一次就行了，第二次来刷直接跳过这一步。
          </p>
        </div>
      </div>
    </div>
  );
}

export default TokenAuthorizationTutorial; 